import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const isLoggedIn = !!localStorage.getItem('token'); // Example logic
  if (isLoggedIn) {
    return true;
  }

  // Redirect if not logged in
  window.alert('You must be logged in');
  window.location.href = '/login';
  return false;
};
